<div class="form-group-outer-container">
    <form *ngIf="myForm" [formGroup]="myForm">
        <div fxLayout="column" fxLayoutGap="20">
            <div fxLayout="column" fxLayoutGap="10">
                <ng-template #nodeTemplateRef let-node="node" let-formElement="formElement">
                    <div fxLayout="column" fxLayoutGap="20px">
                        <div *ngIf="node.type == 'group' && node.group">
                            <div [formGroup]="formElement" class="form-group-container">
                                <eight-cap-card [title]="node.label" fxLayout="column" fxLayoutGap="20px">
                                    <ng-template
                                        *ngFor="let item of node.group"
                                        [ngTemplateOutlet]="nodeTemplateRef"
                                        [ngTemplateOutletContext]="{
                                            node: item,
                                            formElement: formElement.controls[item.name]
                                        }">
                                    </ng-template>
                                </eight-cap-card>
                            </div>
                        </div>
                        <div *ngIf="node.type == 'array' || node.type == 'map'" [formGroup]="formElement">
                            <div class="form-group-container">
                                <eight-cap-card [title]="node.label" fxLayout="column" fxLayoutGap="20px">
                                    <div *ngFor="let array of formElement.controls; let i = index">
                                        <div [formGroup]="formElement" class="form-array-container" fxLayout="row">
                                            <div *ngIf="!node.group" fxLayout="column" fxLayoutGap="20px" fxFlex="90">
                                                <mat-form-field>
                                                    <mat-label>{{ node.label }}</mat-label>
                                                    <input matInput [formControl]="array" />
                                                </mat-form-field>
                                            </div>
                                            <div *ngIf="node.group" fxLayout="column" fxLayoutGap="20px" fxFlex="90">
                                                <ng-container *ngIf="node.type === 'array'">
                                                    <ng-template
                                                        *ngFor="let item of node.group"
                                                        [ngTemplateOutlet]="nodeTemplateRef"
                                                        [ngTemplateOutletContext]="{
                                                            node: item,
                                                            formElement: formElement.controls[i].controls[item.name]
                                                        }">
                                                    </ng-template>
                                                </ng-container>
                                                <ng-container *ngIf="node.type === 'map'">
                                                    <ng-template
                                                        *ngFor="let item of node.group"
                                                        [ngTemplateOutlet]="nodeTemplateRef"
                                                        [ngTemplateOutletContext]="{
                                                            node: item,
                                                            formElement: formElement.controls[i].controls[item.name]
                                                        }">
                                                    </ng-template>
                                                </ng-container>
                                            </div>
                                            <div fxFlex="10">
                                                <button
                                                    mat-icon-button
                                                    (click)="deleteFromFormArray(formElement, i)"
                                                    color="primary"
                                                    title="Delete">
                                                    <mat-icon matPrefix>delete</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        mat-icon-button
                                        (click)="addToFormArray(formElement, node)"
                                        title="Add"
                                        color="primary">
                                        <mat-icon matPrefix>add</mat-icon>Add new entry
                                    </button>
                                </eight-cap-card>
                            </div>
                        </div>
                        <div *ngIf="node.type != 'array' && !node.group">
                            <mat-form-field *ngIf="node.type == 'text' || node.type == 'number'" fxFlex="50">
                                <mat-label>{{ node.label }}</mat-label>
                                <input matInput [formControl]="formElement" />
                            </mat-form-field>
                            <div *ngIf="node.type == 'toggle'" fxFlex="50" class="dynamic-form-field">
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayoutAlign="start center"
                                    fxFlex="1 0 auto"
                                    class="mt-10">
                                    <mat-label>{{ node.label }}</mat-label>
                                    <mat-slide-toggle [formControl]="formElement" color="primary"> </mat-slide-toggle>
                                </div>
                            </div>
                            <mat-form-field *ngIf="node.type == 'date'" fxFlex="50" appearance="outline">
                                <mat-label>{{ node.label }}</mat-label>
                                <input matInput [matDatepicker]="date_added_picker" [formControl]="formElement" />
                                <mat-datepicker-toggle matSuffix [for]="date_added_picker"> </mat-datepicker-toggle>
                                <mat-datepicker #date_added_picker></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field *ngIf="node.type == 'multiselect'" fxFlex="50">
                                <mat-label>{{ node.label }}</mat-label>
                                <mat-select [formControl]="formElement" multiple>
                                    <mat-option *ngFor="let option of node.options | keyvalue" [value]="option.value">
                                        {{ option.key }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field *ngIf="node.type == 'singleselect'" fxFlex="40">
                                <mat-label>{{ node.label }}</mat-label>
                                <mat-select [formControl]="formElement">
                                    <mat-option *ngFor="let option of node.options | keyvalue" [value]="option.value">
                                        {{ option.key }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </ng-template>

                <ng-template
                    *ngFor="let item of jsonFormData.data"
                    [ngTemplateOutlet]="nodeTemplateRef"
                    [ngTemplateOutletContext]="{ node: item, formElement: myForm.controls[item.name] }">
                </ng-template>
            </div>

            <div fxLayout="row" fxFlex="1 0 auto" fxLayoutGap="20px">
                <button
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                    fxFlex="15"
                    class="save-button p-24"
                    mat-raised-button
                    color="primary"
                    (click)="saveForm()">
                    <mat-icon class="icon-action">save</mat-icon>
                    <span class="hide-text">{{ 'button_name.save' | translate }}</span>
                </button>
                <button
                    *ngIf="previewButton"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                    fxFlex="15"
                    class="save-button p-24"
                    mat-raised-button
                    color="primary"
                    (click)="previewConfig()">
                    <mat-icon class="icon-action">remove_red_eye</mat-icon>
                    <span class="hide-text">{{ 'button_name.preview' | translate }}</span>
                </button>
            </div>
        </div>
    </form>
</div>
